import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Logo } from './shared';

const SHOP_ITEMS = [
  ['tubers', 'Dahlia Tubers', {}, 'Season One varieties · Sale opens Sept 2027'],
  ['home', 'Fresh Flowers', { scrollToFlowers: true }, 'Farm gate · Wholesale · Pick your own'],
];

const CATEGORIES = [
  ['farmhouse', 'Farmhouse'],
  ['explore', 'Discover Torquay'],
  ['blog', 'Journal'],
  ['contact', 'Contact'],
];

export default function Nav({ page, go }) {
  const [mobile, setMobile] = useState(false);
  const [shopOpen, setShopOpen] = useState(false);
  const nav = (id, extra = {}) => () => { go(id, extra); setMobile(false); setShopOpen(false); };
  const shopActive = page === 'tubers';
  return (
    <>
      <div className={`mobile-nav${mobile ? ' open' : ''}`} id="mobileNav">
        <button className="mobile-nav-close" onClick={() => setMobile(false)}>×</button>
        <button className="nav-link" onClick={nav('home')}>Home</button>
        <span className="mobile-nav-group">Shop</span>
        {SHOP_ITEMS.map(([id, label, extra]) => (
          <button key={label} className={`nav-link mobile-nav-sub${id === 'tubers' ? ' tubers-tab' : ''}`} onClick={nav(id, extra)} data-testid={`mobile-nav-shop-${id}`}>{label}</button>
        ))}
        {CATEGORIES.map(([id, label]) => (
          <button key={id} className="nav-link" onClick={nav(id)} data-testid={`mobile-nav-${id}`}>{label}</button>
        ))}
        <button className="nav-link cta" onClick={nav('tubers', { scrollToJoin: true })}>Join the List</button>
      </div>

      <nav className="nav-two-row">
        <div className="nav-row">
          <div></div>
          <button className="nav-logo" onClick={nav('home')}>
            <Logo size="nav" />
          </button>
          <div className="nav-links">
            <button className="nav-link cta" onClick={nav('tubers', { scrollToJoin: true })}>Join the List</button>
          </div>
          <button className="nav-burger" onClick={() => setMobile(true)} aria-label="Menu">
            <span></span><span></span><span></span>
          </button>
        </div>
        <div className="nav-strip" data-testid="nav-strip">
          <div
            className={`nav-shop${shopOpen ? ' open' : ''}`}
            onMouseEnter={() => setShopOpen(true)}
            onMouseLeave={() => setShopOpen(false)}
          >
            <button
              className={`nav-strip-link tubers-tab${shopActive ? ' active' : ''}`}
              onClick={() => setShopOpen(true)}
              aria-haspopup="true"
              aria-expanded={shopOpen}
              data-testid="nav-strip-shop"
            >
              Shop <ChevronDown size={12} strokeWidth={2} className="nav-shop-chev" />
            </button>
            <div className="nav-shop-menu" data-testid="nav-shop-menu">
              {SHOP_ITEMS.map(([id, label, extra, sub]) => (
                <button key={label} className="nav-shop-item" onClick={nav(id, extra)} data-testid={`nav-shop-${id}`}>
                  <span className="nav-shop-item-t">{label}</span>
                  <span className="nav-shop-item-s">{sub}</span>
                </button>
              ))}
            </div>
          </div>
          {CATEGORIES.map(([id, label]) => (
            <button key={id} className={`nav-strip-link${page === id ? ' active' : ''}`} onClick={nav(id)} data-testid={`nav-strip-${id}`}>{label}</button>
          ))}
        </div>
      </nav>
    </>
  );
}
